import createFetchClient from 'openapi-fetch';
import { BaseUrl } from '~/types/baseUrl';
import createClient from 'openapi-react-query';
import { paths } from './openapi';

const baseUrl: BaseUrl = {
  production: 'https://platform.versori.com/api/switchboard/v1alpha1',
  staging: 'https://platform-staging.versori.com/api/switchboard/v1alpha1',
  development: 'http://127.0.0.1:8080/v1alpha1',
};

export const switchboardApiFetchClient = createFetchClient<paths>({
  baseUrl: import.meta.env.DEV ? baseUrl.development : import.meta.env.VITE_STAGING ? baseUrl.staging : baseUrl.production,
  credentials: 'include',
  mode: 'cors',
  headers: {
    ...(import.meta.env.VITE_API_JWT && {
      'X-Versori-Internal-Token': import.meta.env.VITE_API_JWT,
    }),
  },
});

export const switchboardApi = createClient(switchboardApiFetchClient);
